<template>
  <v-card light :id="`container-${containerId}`" :class="contentClass">
    <div
      class="grey lighten-2"
      style="overflow: hidden; width: 100%; height: 400px"
      :style="{ height: canvasSize.height + 'px' }"
      :id="containerId"
    />
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      absolute
      timeout="4000"
      top
    >
      {{ snackbar.text }}
    </v-snackbar>
    <div
      v-if="!hideLabels"
      class="d-flex align-center gap-2 grey px-4 lighten-3"
      :class="$vuetify.theme.dark ? 'l-4' : ''"
    >
      <div class="d-flex flex-wrap gap-x-4 gap-y-1" v-if="colorMode === 'available'">
        <template v-for="(label, key) in statusLabels">
          <div
            v-if="key !== 'disabled' || showDisabledLabel"
            :key="key"
            class="d-flex gap-2 align-center"
          >
            <v-avatar size="12" :color="statusColors[key]" />
            <p class="mb-0 text-center">{{ label }}</p>
          </div>
        </template>
      </div>
      <div
        class="d-flex flex-wrap gap-x-4 gap-y-1"
        v-if="colorMode === 'color'"
      >
        <div
          v-for="group in tableMap.Groups"
          :key="group.id"
          class="d-flex gap-2 align-center"
        >
          <v-avatar
            size="12"
            :color="group.color"
            :class="group.options.format === 'square' ? 'rounded-sm' : ''"
          />
          <p class="mb-0 text-center">{{ group.name }}</p>
        </div>
        <div class="d-flex gap-2 align-center" v-if="!hideStatusBorder">
          <v-avatar size="12" style="border: 3px solid #f44336" />
          <p class="mb-0 text-center">Indisponivel</p>
        </div>
      </div>

      <!-- <v-spacer />
      <v-btn
        @click="zoomOut"
        :disabled="loading || map?.getZoom() <= editorProps.minZoom"
        small
        icon
      >
        <v-icon small>mdi-magnify-minus</v-icon>
      </v-btn>
      <v-btn
        @click="zoomIn"
        :disabled="loading || map?.getZoom() >= editorProps.maxZoom"
        small
        icon
      >
        <v-icon small>mdi-magnify-plus</v-icon>
      </v-btn> -->
    </div>
  </v-card>
</template>

<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet";

const statusColors = {
  available: "#4caf50b3",
  disabled: "#808080b3",
  reserved: "#ff9800b3",
  pending: "#ff9800b3",
  sold: "#f44336d3",
  inCart: "#ffeb3bd3",
};
const statusLabels = {
  available: "Disponível",
  disabled: "Desabilitado",
  // pendente: "Reservado",
  sold: "Vendido",
  inCart: "No carrinho",
};

export default {
  metaInfo: {
    meta: [
      {
        name: "viewport",
        content: "user-scalable=no, width=device-width, initial-scale=1",
      },
    ],
  },
  name: "TableSelector",
  props: {
    containerId: {
      type: String,
      default: "map-canvas",
    },
    value: {
      type: Object | Array,
      default: null,
    },
    filterGroup: {
      type: String,
      default: null,
    },
    hideStatusBorder: {
      type: Boolean,
      default: false,
    },
    colorMode: {
      type: String,
      default: "color",
    },
    tableMap: {
      type: Object,
      required: true,
      default: () => ({
        backgroundUrl: null,
        Groups: [],
      }),
    },
    tooltip: {
      type: Function | String | Boolean,
      default: () => (table, group) => {
        const status = table.status;
        var baseText = `<b>${group.name} • ${table.name}</b><br /><span>${group.capacity} pessoas</span>`;
        if (status === "available") return baseText;
        return (
          baseText +
          `<br /><i style="color: ${statusColors[status].slice(0, -2)}"> ${
            statusLabels[status]
          } </i>`
        );
      },
    },
    showDisabledLabel: {
      type: Boolean,
      default: false,
    },
    fixedTooltip: {
      type: Boolean,
      default: false,
    },
    party: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    statusGetter: {
      type: Function,
      default: (table) => table.status,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    hideLabels: {
      type: Boolean,
      default: false,
    },
    contentClass: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    dialog: true,
    map: null,
    snackbar: {
      show: false,
      text: "",
      color: "",
    },

    formatsIcons: {
      square: "mdi-square",
      circle: "mdi-circle",
      hexagon: "mdi-hexagon",
    },
    editorProps: {
      minZoom: -2,
      maxZoom: 5,
      zoomSnap: 0,
      arrowStep: 10,
      minSize: 8,
      maxSize: 96,
    },
    canvasSize: {
      aspectRatio: 4 / 3,
      width: 800,
      height: 600,
    },

    statusColors: statusColors,
    statusLabels: statusLabels,
  }),
  methods: {
    zoomIn() {
      this.map.zoomIn();
    },
    zoomOut() {
      this.map.zoomOut();
    },

    // Draw and Canvas
    calculateCanvasSize() {
      const { aspectRatio } = this.canvasSize;
      const { offsetWidth, offsetHeight } = document.getElementById(
        `container-${this.containerId}`
      );
      const canvasWidth = this.width || offsetWidth;
      var canvasHeight = this.height || canvasWidth / aspectRatio;

      this.canvasSize = {
        aspectRatio,
        width: canvasWidth,
        height: canvasHeight,
      };
    },
    async init() {
      this.calculateCanvasSize();
      if (this.map) this.map.remove();
      this.map = L.map(this.containerId, {
        crs: L.CRS.Simple,
        minZoom: this.editorProps.minZoom,
        maxZoom: this.editorProps.maxZoom,
        zoomSnap: this.editorProps.zoomSnap,
        zoom: 0,
        zoomControl: false,
        keyboard: false,

        // tilePane: 5,
        // overlayPane: 10,
        // shadowPane: 15,
        // markerPane: 20,
        // tooltipPane: 25,
        // popupPane: 30,
      });
      this.map.attributionControl.setPrefix(false);
      this.map.attributionControl.addAttribution(this.party.name);

      const bounds = [
        [0, 0],
        [this.canvasSize.height, this.canvasSize.width],
      ];
      this.map.setMaxBounds(bounds);

      try {
        await this.setBackground();
        this.drawTables();
      } catch (e) {
        console.error(e);
      }
    },
    async draw() {
      this.calculateCanvasSize();
      this.drawTables();
      await this.setBackground();
    },
    drawTables() {
      this.removeTableLayers();
      this.tables.forEach((table) => {
        this.drawTable(table.group, table);
      });
    },

    drawTable(group, table) {
      const size = group.options.size / 2;
      const { x, y } = table.position;
      const format = group.options.format;
      const selected = this.selectedTable.some(
        (t) => t?.id === table.id && t?.group?.id === group.id
      );
      var el;
      var fillColor = group.color;
      var color = "transparent";
      var wight = 3;
      var disabled = false;
      if (this.filterGroup && this.filterGroup !== group.id) return;

      const status = this.statusGetter(table);
      if (this.colorMode === "available") {
        fillColor = this.statusColors[status] || "#ccc";
        if (status !== "available") disabled = true;
      } else if (this.colorMode === "color") {
        if (status !== "available" && !this.hideStatusBorder) {
          color = (this.statusColors[status] || "#CCCCCCCC").slice(0, -2);
          wight = 6;
        }
      }

      if (format == "square")
        el = L.rectangle(
          [
            [x - size, y - size],
            [x + size, y + size],
          ],
          {
            color: selected ? "#6462e7" : color,
            fillColor: fillColor,
            weight: wight,
            fillOpacity: 1,
          }
        );
      else
        el = L.circle([x, y], {
          color: selected ? "#6462e7" : color,
          fillOpacity: 1,
          fillColor: fillColor,
          radius: size,
          weight: wight,
        });

      if (this.tooltip) {
        const tooltipText =
          typeof this.tooltip === "function"
            ? this.tooltip(table, group)
            : this.tooltip;
        el.bindTooltip(tooltipText, {
          permanent: this.fixedTooltip,
          direction: "top",
          className: "rounded-lg",
        }).addTo(this.map);
      }

      if (!disabled) el.on("click", () => this.selectTable(table, group));
    },
    setBackground() {
      return new Promise((resolve, reject) => {
        try {
          const { backgroundUrl } = this.tableMap;
          const img = new Image();
          const url = backgroundUrl;
          img.src = url;
          img.onload = () => {
            this.removeImageLayers();
            const bounds = [
              [0, 0],
              [img.height, img.width],
            ];

            const image = L.imageOverlay(url, bounds);
            image.addTo(this.map);
            const map = this.map;
            this.map.on("drag", function () {
              map.panInsideBounds(bounds, { animate: false });
            });

            this.map.setMaxBounds(bounds);
            this.map.fitBounds(bounds);
            this.$nextTick(() => {
              setTimeout(() => {
                this.map.invalidateSize();
                this.map.options.minZoom = this.map.getZoom();
              }, 100);
            });

            resolve();
          };
          img.onerror = reject;
        } catch (error) {
          console.error(error);
          reject(error);
        }
      });
    },
    removeImageLayers() {
      this.map.eachLayer((layer) => {
        if (layer instanceof L.ImageOverlay) {
          this.map.removeLayer(layer);
        }
      });
    },
    removeTableLayers() {
      this.map.eachLayer((layer) => {
        if (layer instanceof L.Circle || layer instanceof L.Rectangle) {
          layer.off("click");

          this.map.removeLayer(layer);
        }
      });
    },
    selectTable(table, group) {
      var data = table;
      data.group = group;

      if (!this.multiple) {
        this.selectedTable = [data];
        return;
      }

      const index = this.selectedTable.findIndex(
        (t) => t.id === table.id && t.group.id === group.id
      );

      const copy = [...this.selectedTable];

      if (index >= 0) copy.splice(index, 1);
      else copy.push(data);

      this.selectedTable = copy;
    },
    refresh() {
      this.canvasSize.width += 1;
      this.$nextTick(() => {
        this.calculateCanvasSize();
      });
    },
  },
  computed: {
    selectedTable: {
      get() {
        if (!Array.isArray(this.value)) return [this.value].filter((v) => !!v);
        return this.value.filter((v) => !!v);
      },
      set(value) {
        if (!value) {
          this.$emit("input", null);
          return;
        }

        const v = value.map((v) => {
          return {
            ...v,
            group: {
              ...v.group,
              Tables: undefined,
            },
          };
        });

        this.$emit("input", this.multiple ? v : v[0]);
      },
    },
    tables() {
      return this.tableMap.Groups.flatMap((group) =>
        group.Tables.map((t) => {
          t.group = group;

          return new Proxy(t, {
            set: (target, key, value) => {
              if (key === "name") {
                target.name = value;
                this.drawTables();
              }
              if (key === "sellOnline") target.sellOnline = value;
              if (key === "disabled") target.disabled = value;

              return true;
            },
          });
        })
      );
    },
  },
  watch: {
    tableMap: {
      handler() {
        this.draw();
      },
      deep: true,
    },
    filterGroup() {
      this.draw();
    },
    colorMode() {
      this.draw();
    },
    value() {
      this.drawTables();
    },
    width() {
      this.calculateCanvasSize();
    },
    height() {
      this.calculateCanvasSize();
    },
  },
  mounted() {
    this.init();
    window.addEventListener("resize", this.calculateCanvasSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateCanvasSize);
  },
};
</script>

<style lang="scss">
.leaflet-interactive:focus {
  outline: none;
}
.leaflet-control-container {
  div {
    z-index: 3 !important;
  }
}
.leaflet-pane {
  z-index: 3 !important;
}
.leaflet-control {
  z-index: 4 !important;
}
</style>
